import { render, staticRenderFns } from "./czfx.vue?vue&type=template&id=70c9b35f&scoped=true&"
import script from "./czfx.vue?vue&type=script&lang=js&"
export * from "./czfx.vue?vue&type=script&lang=js&"
import style0 from "./czfx.vue?vue&type=style&index=0&id=70c9b35f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9b35f",
  null
  
)

export default component.exports